import React from 'react';
import {
  Atom,
  Server,
  Database as DatabaseIcon,
  Wind,
  Leaf,
  Braces,
  Layers,
  CircleDashed,
  Code,
  Smartphone
} from "lucide-react";

const techStack = [
  {
    category: 'Technology Stack',
    technologies: [
      { name: 'Laravel', icon: <Leaf className="w-12 h-12" />, color: '#FF2D20' },
      { name: 'React', icon: <Atom className="w-12 h-12" />, color: '#61DAFB' },
      { name: 'Next.js', icon: <CircleDashed className="w-12 h-12" />, color: '#ffffff' },
      { name: 'Vue.js', icon: <Wind className="w-12 h-12" />, color: '#42B883' },
      { name: 'Node.js', icon: <Server className="w-12 h-12" />, color: '#68A063' },
      { name: 'Express.js', icon: <Braces className="w-12 h-12" />, color: '#F7DF1E' },
      { name: 'Spring Boot', icon: <Layers className="w-12 h-12" />, color: '#6DB33F' },
      { name: 'Quarkus', icon: <Code className="w-12 h-12" />, color: '#4695EB' },
      { name: 'Kotlin', icon: <Code className="w-12 h-12" />, color: '#7F52FF' },
      { name: 'Flutter', icon: <Smartphone className="w-12 h-12" />, color: '#02569B' },
      { name: 'PostgreSQL', icon: <DatabaseIcon className="w-12 h-12" />, color: '#336791' },
      { name: 'MySQL', icon: <DatabaseIcon className="w-12 h-12" />, color: '#F29111' }
    ]
  }
];
const TechStack = () => {
  return (
    <section id="tech" className="relative py-32 px-6" data-testid="tech-stack-section">
      <div className="max-w-7xl mx-auto">
        <div className="section-divider mb-20"></div>
        
        <div className="text-center mb-16" data-aos="fade-up">
          <h2 className="text-4xl font-bold mb-4" data-testid="tech-stack-title">Our Technology Stack</h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Leveraging industry-leading technologies to build exceptional solutions
          </p>
        </div>
        
        <div className="space-y-16">
          {techStack.map((category, catIndex) => (
            <div key={catIndex} data-aos="fade-up" data-aos-delay={catIndex * 100}>
              <h3 className="text-2xl font-semibold text-[#00E5FF] mb-8 text-center" data-testid={`tech-category-title-${catIndex}`}>
               
              </h3>
              
              <div className="grid md:grid-cols-3 gap-6">
                {category.technologies.map((tech, techIndex) => (
                  <div 
                    key={techIndex}
                    className="glass-card p-8 flex flex-col items-center justify-center text-center group cursor-pointer"
                    data-testid={`tech-item-${catIndex}-${techIndex}`}
                  >
                    <div 
                      className="mb-6 transition-transform group-hover:scale-110 duration-300"
                      style={{ color: tech.color }}
                    >
                      {tech.icon}
                    </div>
                    
                    <h4 className="text-xl font-semibold mb-4">{tech.name}</h4>
                    
                    <div className={`px-4 py-1 rounded-full text-sm border ${
                      category.category === 'Frontend' ? 'border-cyan-500/50 text-cyan-400' :
                      category.category === 'Backend' ? 'border-green-500/50 text-green-400' :
                      category.category === 'Database' ? 'border-blue-500/50 text-blue-400' :
                      'border-orange-500/50 text-orange-400'
                    }`}>
                      {category.category}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;
